<template>
    <div v-if="visible" class="edit-role-components">
        <el-dialog
            :visible.sync="visible"
            :title="id ? $t('Role.edit') : $t('Role.add')"
            left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="140px"
                label-suffix=":">
                <el-form-item prop="nameZh" :label="$t('Role.name')">
                    <el-input
                        style="width: 274px;"
                        v-model="form.nameZh"
                        :placeholder="$t('Role.fill_name')">
                    </el-input>
                </el-form-item>
                <el-form-item prop="nameEs" :label="$t('Role.name2')">
                    <el-input
                        style="width: 274px;"
                        v-model="form.nameEs"
                        :placeholder="$t('Role.fill_name')">
                    </el-input>
                </el-form-item>
                <el-form-item v-if="!id" prop="copyRoleId" :label="$t('Role.is_copy')">
                    <el-select
                        v-model="form.copyRoleId"
                        :placeholder="$t('Role.no_copy')"
                        style="width: 274px;">
                        <el-option
                            v-for="(item, index) in roles"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="mt-8 handle-role-footer">
                <el-button @click="confirm" type="primary">{{ $t('Message.confirm') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog} from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            id: null,
            visible: false,
            form: {
                nameZh: '',
                nameEs: '',
                copyRoleId: null,
            },
            rules: {
                nameZh: { required: true, message: this.$t('Role.fill_name'), type: 'string' },
                nameEs: { required: true, message: this.$t('Role.fill_name'), type: 'string' },
                copyRoleId: { required: true, type: 'number' },
            },
            roles: null,
        };
    },
    created() {
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            // 清空form数据
            this.$refs.form.resetFields();
            this.role = {
                nameZh: '',
                nameEs: '',
                copyRoleId: null,
            };
        },
        open(id) {
            this.visible = true;
            this.id = Number(id);
            if (!id) this.fetchRole();
            if (id) this.fetchData();
        },
        fetchRole() {
            API.get('role/list').then(res => {
                this.roles = res;
                this.roleId = res[0].id;
            });
        },
        fetchData() {
            API.get(`role/${this.id}`).then(res => {
                this.form = res;
            });
        },
        confirm() {
            let required;
            const form = Object.assign({}, this.form);
            if (!this.id) required = API.post('role', form);
            else {
                delete form.copyRoleId;
                required = API.put(`role/${this.id}`, form);
            }
            required.then(() => {
                const  msg = this.id ? this.$t('Role.edit_success') : this.$t('Role.add_success');
                $ele.$message.success(msg);
                this.visible = false;
                this.$emit('fetchRole');
            });
        },
    },
};
</script>

<style lang="scss">
.edit-role-components {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 65px 0 25px;
    }
}
.handle-role-footer {
    margin-left: 140px;
}
</style>
